import instance from "../../utils/axios"; // path to your axios file

// Fetch All or by ID
export const fetchMinistries = async (payload = {}) => {
  const formData = new URLSearchParams();
  Object.entries(payload).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      formData.append(key, val);
    }
  });
  if (!formData.has("typeofentity")) {
    formData.append("typeofentity", "3");
  }

  const response = await instance.post("/churches/readcms", formData);
  return response.data;
};

// Save Ministry
export const saveMinistry = async (inputs) => {
  const formData = new URLSearchParams();
  Object.entries(inputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/save", formData); // ✅ same URL
  return response.data;
};

// Delete Ministry
export const deleteMinistry = async (_id) => {
  const formData = new URLSearchParams();
  formData.append("_id", _id);

  const response = await instance.post("/churches/delete", formData); // ✅ same URL
  return response.data;
};

// Update Ministry
export const updateMinistry = async (inputs) => {
  const formData = new URLSearchParams();
  Object.entries(inputs || {}).forEach(([key, val]) =>
    formData.append(key, val || "")
  );

  const response = await instance.post("/churches/update", formData); // ✅ same URL
  return response.data;
};

// Fetch Ministry by ID
export const fetchMinistryById = async (_id) => {
  const formData = new URLSearchParams();
  formData.append("typeofentity", "3");
  formData.append("_id", _id);

  const response = await instance.post("/churches/readcms", formData);
  return response.data;
};
